

// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { all_routes } from "../../router/all_routes";
// import { Table } from "antd";
// import { TableData } from "../../../core/data/interface";

// const data: any[] = [];

//   const columns = [
//     {
//       title: "Application ID",
//       dataIndex: "ApplicationId",
//       sorter: (a: TableData, b: TableData) =>
//         a.ApplicationId.length - b.ApplicationId.length,
//     },
//     {
//       title: "Trader Name",
//       dataIndex: "TraderName",
//       sorter: (a: TableData, b: TableData) =>
//         a.TraderName.length - b.TraderName.length,
//     },
//     {
//       title: "Applicant Type",
//       dataIndex: "ApplicantType",
//       sorter: (a: TableData, b: TableData) =>
//         a.ApplicantType.length - b.ApplicantType.length,
//     },
//     {
//       title: "License Period",
//       dataIndex: "LicensePeriod",
//       sorter: (a: TableData, b: TableData) =>
//         a.LicensePeriod.length - b.LicensePeriod.length,
//     },
//     {
//       title: "APMC",
//       dataIndex: "APMC",
//       sorter: (a: TableData, b: TableData) =>
//         a.APMC.length - b.APMC.length,
//     },
//     {
//       title: "Applied date",
//       dataIndex: "Applieddate",
//       sorter: (a: TableData, b: TableData) =>
//         a.Applieddate.length - b.Applieddate.length,
//     },
//     {
//       title: "Application Status",
//       dataIndex: "ApplicationStatus",
//       sorter: (a: TableData, b: TableData) =>
//         a.ApplicationStatus.length - b.ApplicationStatus.length,
//     },
    
//   ];


// const MyApplications: React.FC = () => {
  
//   const [selectedAction, setSelectedAction] = useState<string>(""); 

  

//   return (
//     <div>
//       <div className="page-wrapper cardhead">
//         <div className="content container-fluid">
//           <div className="page-header">
//             <div className="row">
//               <div className="col">
//                 <h3 className="page-title">My Application</h3>
//               </div>
//             </div>
//           </div>
//           <div className="col-md-3">
//           <div className="mt-3">
//             <label className="form-label ">
//               Select Action:
//             </label>
//             <select
//               className="form-select col-md-3"
//               value={selectedAction}
//               // onChange={(e) => handleActionChange(e.target.value)}
//             >
//               <option value="">Select Action</option>
//               <option value="Acknowledge and View">Acknowledge and View</option>
//               <option value="Awaiting DR Review">Awaiting DR Review</option>
//             </select>
//           </div>
//           </div>
//           <div className="mt-3">
//             <div className="row">
//               <div className="col-xl-12">
//               <div className="card-body">
//               <Table dataSource={data} columns={columns} />
//               </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default MyApplications;


import React, { useState } from "react";
import { Table } from "antd";
// import { TableData } from "../../../core/data/interface";

interface MyApplicationData {
  key: string;
  ApplicationId: string;
  TraderName: string;
  ApplicantType: string;
  LicensePeriod: string;
  APMC: string;
  Applieddate: string;
  ApplicationStatus: string;
}





const columns = [
  {
    title: "Application ID",
    dataIndex: "ApplicationId",
    sorter: (a: MyApplicationData, b: MyApplicationData) =>
      a.ApplicationId.length - b.ApplicationId.length,
  },
  {
    title: "Trader Name",
    dataIndex: "TraderName",
    sorter: (a: MyApplicationData, b: MyApplicationData) =>
      a.TraderName.length - b.TraderName.length,
  },
  {
    title: "Applicant Type",
    dataIndex: "ApplicantType",
    sorter: (a: MyApplicationData, b: MyApplicationData) =>
      a.ApplicantType.length - b.ApplicantType.length,
  },
  {
    title: "License Period",
    dataIndex: "LicensePeriod",
    sorter: (a: MyApplicationData, b: MyApplicationData) =>
      a.LicensePeriod.length - b.LicensePeriod.length,
  },
  {
    title: "APMC",
    dataIndex: "APMC",
    sorter: (a: MyApplicationData, b: MyApplicationData) =>
      a.APMC.length - b.APMC.length,
  },
  {
    title: "Applied date",
    dataIndex: "Applieddate",
    sorter: (a: MyApplicationData, b: MyApplicationData) =>
      a.Applieddate.length - b.Applieddate.length,
  },
  {
    title: "Application Status",
    dataIndex: "ApplicationStatus",
    sorter: (a: MyApplicationData, b: MyApplicationData) =>
      a.ApplicationStatus.length - b.ApplicationStatus.length,
  },
];


const MyApplications: React.FC = () => {
  const [selectedAction, setSelectedAction] = useState<string>("");
  const initialData: MyApplicationData[] = [
    {
      key: "1",
      ApplicationId: "APP001",
      TraderName: "Puneet Singh",
      ApplicantType: "Individual",
      LicensePeriod: "2023-2025",
      APMC: "Market A",
      Applieddate: "2024-01-15",
      ApplicationStatus: "Acknowledge and View",
    },
    {
      key: "2",
      ApplicationId: "APP002",
      TraderName: "Akshit Singh",
      ApplicantType: "Company",
      LicensePeriod: "2022-2024",
      APMC: "Market B",
      Applieddate: "2024-02-10",
      ApplicationStatus: "Awaiting DR Review",
    },
    {
      key: "3",
      ApplicationId: "APP003",
      TraderName: "Mark Johnson",
      ApplicantType: "Individual",
      LicensePeriod: "2023-2026",
      APMC: "Market C",
      Applieddate: "2024-03-05",
      ApplicationStatus: "Acknowledge and View",
    },
  ];

  
  // Filter data based on selected action
  const filteredData = selectedAction
    ? initialData.filter((item) => item.ApplicationStatus === selectedAction)
    : initialData;

  return (
    <div>
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col">
                <h3 className="page-title">My Application</h3>
              </div>
            </div>
          </div>

          {/* Select Action Dropdown */}
          <div className="col-md-3">
            <div className="mt-3">
              <label className="form-label">Select Action:</label>
              <select
                className="form-select col-md-3"
                value={selectedAction}
                onChange={(e) => setSelectedAction(e.target.value)}
              >
                <option value="">Select Action</option>
                <option value="Acknowledge and View">Acknowledge and View</option>
                <option value="Awaiting DR Review">Awaiting DR Review</option>
              </select>
            </div>
          </div>

          {/* Filtered Table */}
          <div className="mt-3">
            <div className="row">
              <div className="col-xl-12">
                <div className="card-body">
                  <Table dataSource={filteredData} columns={columns} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyApplications;
